
import { createTheme } from '@mui/material/styles';
export const darkBg = 'rgb(15, 21, 17)';
export const darkTxt = 'rgb(222, 228, 222)';
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(141, 213, 178)',
      contrastText: 'rgb(0, 56, 37)',
    },
    secondary: {
      main: 'rgb(180, 204, 189)',
      contrastText: 'rgb(31, 53, 42)',
    },
    tertiary: {
      main: 'rgb(165, 204, 222)',
      contrastText: 'rgb(7, 53, 67)',
    },
    error: {
      main: 'rgb(255, 180, 171)',
      contrastText: 'rgb(105, 0, 5)',
    },
    background: {
      default: 'rgb(15, 21, 17)',
      paper: 'rgb(15, 21, 17)',
    },
    surface: {
      main: 'rgb(15, 21, 17)',
      variant: 'rgb(64, 73, 67)',
      dim: 'rgb(15, 21, 17)',
      bright: 'rgb(53, 59, 55)',
      container: 'rgb(27, 33, 29)',
      containerLow: 'rgb(23, 29, 25)',
      containerHigh: 'rgb(37, 43, 40)',
    },
    text: {
      primary: 'rgb(222, 228, 222)',
      secondary: 'rgb(191, 201, 193)',
      disabled: 'rgb(138, 147, 140)',
      hint: 'rgb(77, 70, 57)',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
  },
});

export const lightBg = 'rgb(245, 251, 245)';
export const lightTxt = 'rgb(23, 29, 25)';
 export  const lightTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: 'rgb(33, 106, 77)',
        contrastText: 'rgb(255, 255, 255)',
      },
      secondary: {
        main: 'rgb(77, 99, 87)',
        contrastText: 'rgb(255, 255, 255)',
      },
      tertiary: {
        main: 'rgb(61, 99, 115)',
        contrastText: 'rgb(255, 255, 255)',
      },
      error: {
        main: 'rgb(186, 26, 26)',
        contrastText: 'rgb(255, 255, 255)',
      },
      background: {
        default: 'rgb(245, 251, 245)',
        paper: 'rgb(245, 251, 245)',
      },
      surface: {
        main: 'rgb(245, 251, 245)',
        variant: 'rgb(220, 229, 221)',
        dim: 'rgb(214, 219, 214)',
        bright: 'rgb(245, 251, 245)',
        container: 'rgb(234, 239, 233)',
        containerLow: 'rgb(239, 245, 239)',
        containerHigh: 'rgb(228, 234, 228)',
      },
      text: {
        primary: 'rgb(23, 29, 25)',
        secondary: 'rgb(64, 73, 67)',
        disabled: 'rgb(112, 121, 115)',
        hint: 'rgb(64, 73, 67)',
      },
    },
    typography: {
      fontFamily: 'Comfortaa, sans-serif',
    },
  });
  